export default {"src":"/_next/static/media/splodge.48261c28.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};